export function convertArrayToQueryParameterArray(array: any[]) {
  if (array.length === 0) return undefined;

  let queryParameter = '';
  queryParameter = queryParameter.concat(array.shift());

  array.forEach((i: any) => {
    queryParameter = queryParameter.concat(`,${i}`);
  });

  return queryParameter;
}
